export const ENTRY_PAGE_SIZES = [20, 50, 100, 200];

export const DEFAULT_ENTRY_PAGE_SIZE = 50;

// Drawing every entry on one page crashes the browser tab long before 90,000 entries;
// Export gets every entry without drawing them.
export const SHOW_ALL_LIMIT = 500;

export const SHOW_ALL_LIMIT_MESSAGE =
  `Show All is limited to ${SHOW_ALL_LIMIT} entries. Showing more at once can make your browser ` +
  'stop responding. Use Export to get every entry.';
